export default {
	blue: "#0984E3",
	red: "#D63031",
	yellow: "#fcaa13",
	purple: "#8E44AD",
	green: "#27AE60",
	white: "#fefefe",
	edcBlue: "#2e3a6e",
}